import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_ENABLE_SUBSCRIPTIONS_FOR = createFcmDetails('enable_subscriptions_for', {
	owner: 'Payments',
	context: 'Page header and Membership features',
	description: 'Indicates if membership is enabled for a specific country',
	import: false,
});
